import { BorderBox } from "@/components/atoms/BorderBox";
import { QuestionMissingInInstanceChangeProps } from ".";
import { ListTodo } from "lucide-react";

export function QuestionMissingInInstanceChange({ templateQuestion }: QuestionMissingInInstanceChangeProps) {
    return (
        <BorderBox size={"sm"} className="flex flex-col items-start" >
            <h4 className="font-semibold flex gap-1 items-center"><ListTodo size="16"/>Question is missing in instance</h4>
            <div className="flex flex-col w-full gap-2">
                <div className="text-xs text-muted-foreground">
                    Question: <i><b>{templateQuestion.question}</b></i> will be added to the instance.
                </div>
            </div>
        </BorderBox>
    )
}